import React from "react";
import s from "./Index.module.scss";
import Search from "../../components/Search";
import logo from "../../images/logo-text.svg";
import bg from "../../images/background.png";
import SelectOptions from "../../components/SelectOptions";

const Index = () => (
  <div className={s.container}>
    <img src={bg} alt="logo" className={s.globeBackground} />
    <div className={s.content}>
      <div className={s.logo}>
        <img src={logo} alt="logo" />
      </div>
      <Search className={s.search} />
      <SelectOptions />
    </div>
    <div className={s.cover} />
  </div>
);

export default Index;
